import { ContactReferrerArrangement } from '@features/contacts/models';
import { OpportunityReferrerArrangement } from '@features/opportunities/services/opportunity-summary.contract';
import { CreditAdviceFeeType } from '@shared/components/credit-advice-fee/models/credit-advice-fee';

export namespace CreateOpportunityRequest {
  export namespace ReferrerArrangement {
    export interface Contract {
      referrer: ContactReferrerArrangement.Type;
      arrangement?: OpportunityReferrerArrangement.SchemaContract | null;
    }

    export interface Model {
      referrer: ContactReferrerArrangement.Type;
      arrangement: OpportunityReferrerArrangement.Model | null;
    }

    export function toContract(r: Model): Contract {
      if (r.referrer === ContactReferrerArrangement.Type.No) {
        return {
          referrer: ContactReferrerArrangement.Type.No
        };
      }

      return {
        referrer: r.referrer,
        arrangement: OpportunityReferrerArrangement.toSchemaContract(
          r.arrangement
        )
      };
    }
  }

  export type ChargedAdviceFeeContract = {
    feeType: CreditAdviceFeeType;
    amount: number;
  };

  export type AdviceFeeContract = {
    charged?: ChargedAdviceFeeContract;
    waived?: {};
  };

  export interface Contract {
    name: string;
    estimatedAmount: number;
    adviceFee?: AdviceFeeContract | null;
    source: string | null;
    adviserCampaignId: string | null;
    referrerArrangement: ReferrerArrangement.Contract;
  }

  export interface Model {
    name: string;
    estimatedAmount: number;
    waiveAdviceFee: boolean;
    creditAdviceFee: {
      feeType: CreditAdviceFeeType;
      amount: number;
    } | null;
    source: string | null;
    adviserCampaignId: string | null;
    referrerArrangement: ReferrerArrangement.Model;
  }

  export function toContract(c: Model): Contract {
    let adviceFee: AdviceFeeContract | undefined = undefined;

    if (c.waiveAdviceFee) {
      adviceFee = { waived: {} };
    } else if (c.creditAdviceFee) {
      const charged: ChargedAdviceFeeContract = {
        feeType: c.creditAdviceFee.feeType,
        amount: c.creditAdviceFee.amount
      };
      adviceFee = { charged };
    }

    return {
      name: c.name,
      estimatedAmount: c.estimatedAmount,
      adviceFee: adviceFee,
      source: c.source,
      adviserCampaignId: c.adviserCampaignId,
      referrerArrangement: ReferrerArrangement.toContract(c.referrerArrangement)
    };
  }
}
